import api, { authHeader, pdfHeader } from "./config";

class examApi {
    static getExam = (query) => api.get("/exam/me", {params: {q: query.q, offset: query.offset, page: query.page}, headers: authHeader()});

    static getPdf = (report_id) =>
        api.get(`/report/${report_id}/pdf`, {
            responseType: 'blob',
            headers: pdfHeader()
        })
}

export default examApi;